export default __webpack_public_path__ + "static/media/x.1a80430b.svg";